/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Spinner_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading" |
*
* @param {Ui_Spinner_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const ui_spinner_loading = /** @type {((inputs?: Ui_Spinner_LoadingInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Spinner_LoadingInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird geladen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("加载中")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("載入中")
	if (locale === "ko") return /** @type {LocalizedString} */ ("불러오는 중")
	return /** @type {LocalizedString} */ ("Loading")
});